import React from 'react';
import queryString from 'query-string';
import copy from 'copy-to-clipboard';

import { downloadURI } from './utils/Download';

import {
    Container,
    Grid,
    Typography,
    Button,
    Box,
    Chip,
    TextField,
    IconButton,
    Tooltip,
    Link
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Alert from '@material-ui/lab/Alert';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DoneIcon from '@material-ui/icons/Done';
import VideoCallIcon from '@material-ui/icons/VideoCall';

import Header from './Header';

import Video from './Video';
import Render from './Render';

import Comment from './Comment';

import AudioAction from './AudioAction';
import VideoAction from './VideoAction';

import DownloadDesktopApp from './DownloadDesktopApp';

interface IQueryParameter {
    srcAudio?: string;
    srcVideo?: string;
    merge?: boolean;
    isDashManifestVideo: boolean;
}

interface IState {
    centerMessage: string;
    isRendering: boolean;

    srcVideo?: string;
    srcAudio?: string;
    isDashManifestVideo: boolean;

    merge: boolean;

    currentTimeVideo?: any;

    audioAction: 'add' | 'remove' | 'none';
    startTrim?: number;
    endTrim?: number;

    srcVideoPreview?: string;
    videoOutput: Uint8Array | null;
}

export default class App extends React.Component<{}, IState> {
    public player: any = null;

    private outputFileRef: any = React.createRef();

    state: Readonly<IState> = {
        centerMessage: '',
        merge: false,
        isRendering: false,
        isDashManifestVideo: false,
        audioAction: 'none',
        videoOutput: null,
    };

    componentDidMount() {
        const parsed: any = queryString.parse((window as any).location.search);
        let newState: any = {};
        if (typeof (parsed as IQueryParameter).srcVideo !== undefined) {
            newState['srcVideo'] = parsed.srcVideo;
        }
        if (typeof (parsed as IQueryParameter).srcAudio !== undefined) {
            newState['srcAudio'] = parsed.srcAudio;
        }
        if (typeof parsed.isDashManifestVideo !== undefined) {
            newState['isDashManifestVideo'] =
                parsed.isDashManifestVideo === 'true' ? true : false;
        }
        if (typeof (parsed as IQueryParameter).merge !== undefined) {
            newState['merge'] = parsed.merge;
        }

        this.setState(newState);
    }

    setCenterMessage = (message: string) => {
        this.setState({ centerMessage: message });
    };

    setIsRenderRing = (bool: boolean) => {
        this.setState({ isRendering: bool });
    };

    handleVideoStateChange = (state: any) => {
        if (this.player === null) return;
        const currentTime: number = state.currentTime as number;
        const { startTrim, endTrim } = this.state;
        if (
            typeof startTrim !== 'undefined' &&
            startTrim > 0 &&
            currentTime < startTrim
        ) {
            this.player.seek(startTrim);
            return;
        }
        if (
            typeof endTrim !== 'undefined' &&
            endTrim > 0 &&
            currentTime > endTrim
        ) {
            this.player.seek(startTrim);
            return;
        }
    };

    restartPlayer = () => {
        this.setMuted(false);
        this.setTrimTime(0, 0);
    };

    setMuted = (muted: boolean) => {
        if (this.player !== null) {
            this.player.muted = muted;
        }
    };

    setAudioAction = (action: 'add' | 'remove' | 'none') => {
        if (action === 'remove') {
            this.player.muted = true;
        } else if (action === 'add') {
            this.player.muted = false;
        } else if (action === 'none') {
            this.player.muted = false;
        }
        this.setState({ audioAction: action });
    };

    setTrimTime = (startTrim: number, endTrim: number) => {
        this.setState({
            startTrim,
            endTrim,
        });
    };

    // Ref player react library
    setPlayer = (player: any) => {
        this.player = player;
        if (this.player !== null) {
            this.player.subscribeToStateChange(this.handleVideoStateChange);
        }
    };

    // When convert success
    triggerChangeVideo = (videoData: Uint8Array) => {
        var srcBlob = URL.createObjectURL(new Blob([videoData.buffer]));
        this.setState({ srcVideoPreview: srcBlob, videoOutput: videoData });
        this.restartPlayer();
    };

    // Choose source video to display
    playerSourceVideo = (): string | null => {
        // Priority video preview as first
        if (typeof this.state.srcVideoPreview !== 'undefined')
            return this.state.srcVideoPreview as string;

        // Source video second
        if (typeof this.state.srcVideo !== 'undefined') {
            return this.state.srcVideo as string;
        }

        // Source Audio third
        if (typeof this.state.srcAudio !== 'undefined') {
            return this.state.srcAudio as string;
        }

        return null;
    };

    displayTrimStatus = () => {
        if (
            (typeof this.state.startTrim !== 'undefined' &&
                this.state.startTrim > 0) ||
            (typeof this.state.endTrim !== 'undefined' &&
                this.state.endTrim > 0)
        )
            return (
                <Grid item>
                    <Chip
                        size='small'
                        icon={<DoneIcon />}
                        label='Apply trim video'
                        clickable={false}
                        color='secondary'
                    />
                </Grid>
            );
    };

    handleUploadFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files === null || files.length > 1) return;

        const file = files.item(0);
        const url = URL.createObjectURL(file);
        this.setState({ srcVideo: url });
    };

    downloadVideo = () => {
        let outputFileName = this.outputFileRef.current.value as string;
        if (outputFileName === '') outputFileName = 'Video-DYL';
        downloadURI(
            this.state.videoOutput as Uint8Array,
            outputFileName + '.mp4',
            'application/octet-stream'
        );
    };

    render() {
        return (
            <Container>
                <Grid container justify='center'>
                    <Header />

                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center'>
                            <Link target='_blank' href="https://www.youtube.com/watch?v=wNesQ77bFdY&t=2s">How To Use</Link>
                            {/* <iframe
                                width='560'
                                height='315'
                                src=''
                                title='YouTube video player'
                                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                allowFullScreen
                            ></iframe> */}
                        </Box>
                    </Grid>

                    {/* Alert 2GB Maximum */}
                    <Grid item xs={12}>
                        <Box m={2} display='flex' justifyContent='center'>
                            <Alert severity='warning'>
                                - Currently can handle video maximum 2 GB (1
                                hour video and below), video have more than one
                                hour see 'Download DYL Editor App(Windows Only)'
                                or scroll down the webpage to read the comment!
                                <br />- Hiện tại có thể xử lý video tối đa 2 GB
                                (video 1 giờ trở xuống), video có hơn một giờ
                                xem 'Download DYL Editor App(Windows Only)' hoặc
                                cuộn xuống trang web để đọc bình luận!
                            </Alert>
                        </Box>
                    </Grid>

                    <Grid>
                        <Box display='flex' flexDirection='row'>
                            <Tooltip title='Copy this URL and paste to DYL Editor App'>
                                <IconButton
                                    onClick={() => {
                                        copy(window.location.href);
                                        alert('Copy success');
                                    }}
                                >
                                    <FileCopyIcon />
                                </IconButton>
                            </Tooltip>

                            <Alert
                                color='success'
                                icon={false}
                                style={{ maxWidth: 300 }}
                            >
                                <Typography>
                                    {window.location.href.substr(0, 30)}...
                                </Typography>
                            </Alert>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <DownloadDesktopApp />
                    </Grid>

                    {/* Info */}
                    {this.state.centerMessage.length > 0 && (
                        <Grid item xs={12}>
                            <Box m={2} display='flex' justifyContent='center'>
                                <Alert severity='info'>
                                    {this.state.centerMessage}
                                </Alert>
                            </Box>
                        </Grid>
                    )}

                    {/* Preview video */}
                    {this.state.videoOutput !== null && (
                        <Grid item xs={12}>
                            <Box m={2}>
                                <Typography
                                    color='secondary'
                                    align='center'
                                    display='block'
                                    variant='subtitle1'
                                >
                                    Preview Your Video
                                </Typography>
                            </Box>
                        </Grid>
                    )}

                    {/* No video or audio file asking add file */}
                    {typeof this.state.srcVideo === 'undefined' &&
                        typeof this.state.srcAudio === 'undefined' && (
                            <Grid item xs={12}>
                                <Box
                                    m={2}
                                    display='flex'
                                    justifyContent='center'
                                >
                                    <Button
                                        variant='contained'
                                        component='label'
                                        color='primary'
                                        startIcon={<VideoCallIcon />}
                                    >
                                        Upload Media
                                        <input
                                            type='file'
                                            hidden
                                            onChange={this.handleUploadFile}
                                        />
                                    </Button>
                                </Box>
                            </Grid>
                        )}

                    {this.playerSourceVideo() !== null && (
                        <Video
                            refFn={this.setPlayer}
                            src={this.playerSourceVideo() as string}
                        />
                    )}

                    {this.state.videoOutput !== null && (
                        <Grid item>
                            <Box display='flex' justifyContent='center' m={2}>
                                <TextField
                                    inputRef={this.outputFileRef}
                                    label='Name File'
                                    defaultValue='Video-DYL'
                                    placeholder='Enter Your File Name'
                                    required
                                />
                            </Box>
                            <Box display='flex' justifyContent='center' m={3}>
                                <Button
                                    startIcon={<CloudDownloadIcon />}
                                    variant='contained'
                                    color='secondary'
                                    onClick={this.downloadVideo}
                                >
                                    Download
                                </Button>
                            </Box>
                        </Grid>
                    )}
                    <AudioAction
                        isDashManifestVideo={this.state.isDashManifestVideo}
                        setAudioAction={this.setAudioAction}
                    />
                    <VideoAction
                        isRendering={this.state.isRendering}
                        setTrimTime={this.setTrimTime}
                    />

                    {this.displayTrimStatus()}

                    <Render
                        setIsRenderRing={this.setIsRenderRing}
                        setCenterMessage={this.setCenterMessage}
                        merge={this.state.merge}
                        srcVideo={this.state.srcVideo}
                        srcAudio={this.state.srcAudio}
                        audioAction={this.state.audioAction}
                        startTrim={this.state.startTrim}
                        endTrim={this.state.endTrim}
                        triggerChangeVideo={this.triggerChangeVideo}
                    />

                    <Grid item>
                        <Box display='flex' justifyContent='center'>
                            <Comment />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}
